import { render } from "./CartUser.vue?vue&type=template&id=21ed2210&scoped=true"
import script from "./CartUser.vue?vue&type=script&lang=js"
export * from "./CartUser.vue?vue&type=script&lang=js"

import "./CartUser.vue?vue&type=style&index=0&id=21ed2210&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21ed2210"]])

export default __exports__